import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { deepExtract } from 'helpers/deep';

var VenueDeriver =
/*#__PURE__*/
function () {
  function VenueDeriver() {
    _classCallCheck(this, VenueDeriver);
  }

  _createClass(VenueDeriver, null, [{
    key: "address",
    value: function address(venue) {
      return Object.keys((venue ? venue.address : null) || {}).map(function (key) {
        return venue.address[key];
      }).filter(function (val) {
        return !!val;
      }).join(', ');
    }
  }, {
    key: "sellExperienceMapper",
    value: function sellExperienceMapper(rawVenue) {
      var venue = ['id', 'location', 'name', 'subtitle', 'activities', 'images'].reduce(function (memo, key) {
        return _objectSpread({}, memo, _defineProperty({}, key, rawVenue[key]));
      }, {});
      delete venue.location.name;
      delete venue.location.parent_name;

      if (venue.images) {
        delete venue.images.mobile;
      }

      return venue;
    }
  }, {
    key: "splitActivities",
    value: function splitActivities(venue) {
      if (venue && venue.activities && venue.activities.split) {
        venue.activities = venue.activities.split(',').map(function (str) {
          return str.trim();
        });
      }
    }
  }, {
    key: "mobileImage",
    value: function mobileImage(venue, key) {
      return venue.images && venue.images.mobile && venue.images.mobile[key];
    }
  }, {
    key: "getCountryShortCode",
    value: function getCountryShortCode(venue) {
      return deepExtract('global_location.msa.country.short_code', venue);
    }
  }]);

  return VenueDeriver;
}();

export { VenueDeriver as default };